import { axiosInstance } from "../core/http";

export const tasksApi = {
  continueVideo: (matchId, currentStage) =>
    axiosInstance.post(`/panel/match/${matchId}/command/`, {
      stage: currentStage,
    }),
  restartPipeline: (matchId) =>
    axiosInstance.post(`/panel/match/${matchId}/command/restart/`),
  playPausePiepeline: (matchId, command_type) =>
    axiosInstance.post(`/panel/match/${matchId}/detector/${command_type}/`),
  uploadCache: (matchId) =>
    axiosInstance.post(`/panel/match/${matchId}/super-tracks/upload_cache/`, {}),
};
